import { Command, SearchInput } from '../input';
import { useDialogManager } from '../dialog';
import React, { useEffect } from 'react';
import { T } from 'src/shared/helpers';
import styled from 'styled-components';
import QuickSearchDialog from './quickSearchDialog';

const QuickSearchInput = styled(SearchInput)`
    min-width: 300px;
`;

export default function QuickSearch() {
    const { showDialog } = useDialogManager();

    // Open the dialog with CTRL + K
    useEffect(() => {
        const handleKeyDown = (e: KeyboardEvent) => {
            if (e.ctrlKey && e.key === 'k') {
                e.preventDefault();
                e.stopImmediatePropagation();
                showDialog('quick-search', <QuickSearchDialog />);
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    return (
        <QuickSearchInput
            placeholder={T._('Quick search...', 'Admin')}
            onFocus={(e) => {
                showDialog('quick-search', <QuickSearchDialog />);
            }}
            rightElement={<Command>CTRL + K</Command>}
        />
    );
}
